import React from 'react';
import { useTranslation } from 'react-i18next';
import { OUTRIGHT_ACCENT } from '../theme';

function SportChips({ sports, selectedSportId, onSelect, onBack }) {
  const { t } = useTranslation('translations', { useSuspense: false });

  const allActive = selectedSportId == null;

  const chip = (label, active, onClick, key) => (
    <button
      type="button"
      key={key}
      onClick={onClick}
      className="btn btn-sm rounded-pill d-inline-flex align-items-center flex-shrink-0"
      style={{
        background: active ? OUTRIGHT_ACCENT : 'var(--bs-body-bg)',
        color: active ? '#fff' : 'var(--bs-body-color)',
        border: active ? 'none' : '1px solid var(--bs-border-color)',
        fontWeight: 600,
        whiteSpace: 'nowrap'
      }}
    >
      {label}
    </button>
  );

  return (
    <div
      className="d-flex align-items-center gap-2 overflow-auto px-3 py-2"
      style={{
        scrollbarWidth: 'none',
        borderBottom: '1px solid var(--bs-border-color)'
      }}
    >
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label={t('outrights.back')}
          className="btn btn-sm p-0 d-inline-flex align-items-center justify-content-center flex-shrink-0"
          style={{
            background: 'transparent',
            border: 'none',
            color: 'var(--bs-body-color)',
            width: 28,
            height: 28
          }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M10 3L5 8l5 5"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
      {chip(t('outrights.allSports'), allActive, () => onSelect(null), 'all')}
      {[...sports].sort((a, b) => a.sportId - b.sportId).map((s) =>
        chip(s.sportName, s.sportId === selectedSportId, () => onSelect(s.sportId), s.sportId)
      )}
    </div>
  );
}

export default SportChips;
